import React from 'react';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import { FloatingInput, Button, ClosedSelect } from '@piplapps/pipl-ui';
import { connect } from 'react-redux';
import { getText } from '../../../Utils/TranslationUtils';
import styles from './LeadVettingFormStyles.module.less';
import { COUNTRIES } from '../../../Constants/Common';
import { VettingSelectors } from '../../../Redux/modules/vetting/selectors';
import { trackEvent } from '../utils';
import { validateWebsite } from '../../../Utils/GenericUtils';
import PageviewHandler from '../../../Utils/AnalyticsHandler/PageviewHandler';

const VettingMoreInformation = (props) => {
  const { isLoading } = props;

  const validate = (values) => {
    const errors = {};
    for (const value in values) {
      if (values[value] === '') {
        errors[value] = getText('ERROR_REQUIRED_FIELD');
      }
    }

    if (!validateWebsite(values.website)) {
      errors.website = getText('ERROR_INVALID_WEBSITE');
    }
    return errors;
  };

  const formik = useFormik({
    initialValues: {
      website: '',
      country: '',
      description: '',
    },
    validate,
    onSubmit: (values) => {
      props.onSubmit(values);
      trackEvent('submitMoreInfo', '');
    },
  });

  const getCountryOptions = () => {
    return COUNTRIES.map((field, i) => {
      return {
        label: field[1],
        value: field[0],
      };
    });
  };

  const onBlur = (e, fieldName) => {
    formik.handleBlur(e);
    trackEvent(fieldName, e.target.value);
  };

  return (
    <>
      <PageviewHandler path="more-info/" />
      <div className={styles.form}>
        <div>
          <div className={styles.headerWrapper}>
            <div className={styles.pageTitle}>
              <span>{gettext('Looks like we need a little more information')}</span>
            </div>
            <div className={[styles.pageTitle, styles.subTitle].join(' ')}>
              <span>
                {gettext('Please answer these additional questions for consideration by our manual review team.')}
              </span>
            </div>
          </div>
          <div>
            <form onSubmit={formik.handleSubmit} id="vetting-more-info-form">
              <div className={styles.fieldRow}>
                <FloatingInput
                  id="id_website"
                  name="website"
                  placeholder={gettext('Company Website')}
                  testId="website-input"
                  onChange={formik.handleChange}
                  onBlur={(e) => onBlur(e, 'website')}
                  value={formik.values.website ? formik.values.website : ''}
                  forcedError={formik.errors.website && formik.touched.website ? formik.errors.website : null}
                  error={formik.errors.website}
                />
              </div>
              <div className={styles.fieldRow}>
                <ClosedSelect
                  options={getCountryOptions()}
                  id="id_country"
                  name="country"
                  label={gettext('Company Country')}
                  testId="country-input"
                  setValue={(v) => v}
                  onChange={(v) => formik.setFieldValue('country', v)}
                  onBlur={(e) => onBlur(e, 'country')}
                  height={45}
                />
              </div>
              <div className={styles.fieldRow}>
                <FloatingInput
                  id="id_description"
                  name="description"
                  size="wide"
                  placeholder={gettext('Describe how you will be using Pipl SEARCH')}
                  testId="website-input"
                  onChange={formik.handleChange}
                  onBlur={(e) => onBlur(e, 'description')}
                  value={formik.values.description ? formik.values.description : ''}
                  forcedError={
                    formik.errors.description && formik.touched.description ? formik.errors.description : null
                  }
                  error={formik.errors.description}
                />
              </div>
              <div className={styles.proceedButton}>
                <Button
                  id="submit-button"
                  buttonClass="primary-green"
                  type="submit"
                  text={gettext('Submit Request')}
                  isLoading={isLoading}
                  loadingText={gettext('Saving')}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
VettingMoreInformation.propTypes = {
  isLoading: PropTypes.bool,
  onSubmit: PropTypes.func,
};
const mapStateToProps = (state) => {
  return {
    isLoading: VettingSelectors.vettingLoadingSelector(state),
  };
};
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(VettingMoreInformation);
